import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ShopSliceState {
  sortOrder: 'newest' | 'lowPrice' | 'highPrice' | 'popularity';
  tabName: 'ing' | 'end' | 'all';
  searchKeyword: string;
}

const initialShopState: ShopSliceState = {
  sortOrder: 'popularity',
  tabName: 'all',
  searchKeyword: '',
};

const shopSlice = createSlice({
  name: 'shop',
  initialState: initialShopState,
  reducers: {
    setShopSortOrder: (
      state,
      action: PayloadAction<ShopSliceState['sortOrder']>,
    ) => {
      state.sortOrder = action.payload;
    },
    setShopTabName: (
      state,
      action: PayloadAction<ShopSliceState['tabName']>,
    ) => {
      state.tabName = action.payload;
    },
    setShopSearchKeyword: (
      state,
      action: PayloadAction<ShopSliceState['searchKeyword']>,
    ) => {
      state.searchKeyword = action.payload;
    },
  },
});

export const { setShopSortOrder, setShopTabName, setShopSearchKeyword } =
  shopSlice.actions;

export default shopSlice.reducer;
